import dayjs from 'dayjs';
import { useContext } from 'react';
import { apiBaseURL } from 'config/constants';
import { appActions, AppContext } from 'context/app-context';
import { classnames } from 'helpers/utils';
import { API_ROUTES } from 'networking/api-routes';
import styles from './qr-code-card.module.scss';

interface QrCodeCardProps {
  qrCode: QrCode;
  // Bigger image, for a page where the code is the main thing (Vault Settings).
  large?: boolean;
}

// The code itself, rendered by the API (the same URL that's printed).
const qrCodeImageUrl = (code: string) =>
  `${(apiBaseURL ?? '').replace(/\/$/, '')}${API_ROUTES.QR_CODE_IMAGE(code)}`;

// A printed QR code linked to a vault, album or memory: the scannable code
// (click to see it large) and when it was linked. Scanning it opens what it's
// linked to. The code's ID means nothing to users, so it isn't shown.
export const QrCodeCard = ({ qrCode, large = false }: QrCodeCardProps) => {
  const { dispatch } = useContext(AppContext);
  const image = qrCodeImageUrl(qrCode.code);

  return (
    <div className={styles.card}>
      <button
        type="button"
        className={styles.imageButton}
        aria-label="Enlarge QR code"
        onClick={() =>
          dispatch({
            type: appActions.SET_IMAGE_TO_ENLARGE,
            imageToEnlarge: image,
            isQrCodeImageEnlarged: true,
          })
        }
      >
        <img
          src={image}
          alt="QR code"
          className={classnames(styles.image, { [styles.imageLarge]: large })}
        />
      </button>
      {qrCode.linkDate && (
        <span className={styles.linked}>
          {`Linked ${dayjs(qrCode.linkDate).format('MMM D, YYYY')}`}
        </span>
      )}
    </div>
  );
};
